<template>
  <div class="login-container">
    <login-index>
      <el-form
        ref="accountLoginForm"
        :model="accountForm"
        :rules="accountLoginRules"
        class="login-form"
        hide-required-asterisk
        label-position="top"
        size="small"
        status-icon
        @keyup.enter.native="loginHandle"
      >
        <div class="login-form-title">登录</div>
        <el-form-item class="mb-40 login-form-account" prop="account">
          <span class="login-form-text">账号</span>
          <el-input
            class="login-form-input"
            v-model="accountForm.account"
            placeholder="请输入账号名/手机号/邮箱"
            type="text"
            tabindex="1"
            auto-complete="on"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <span class="login-form-text">密码</span>
          <div style="position: relative">
            <el-input
              class="login-form-input"
              ref="password"
              :type="passwordType"
              :key="passwordType"
              name="password"
              tabindex="2"
              auto-complete="on"
              v-model="accountForm.password"
              placeholder="请输入密码"
              @keyup.enter.native="loginHandle"
            >
            </el-input>
            <span class="show-pwd flex-center" @click="showPwd">
              <svg-icon :name="passwordType === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </div>
          <div class="login-form-tips">{{ errorTips }}</div>
        </el-form-item>

        <div class="flex-space-between login-form-remberPwd">
          <el-checkbox label="记住密码" class="el-login-checkbox" v-model="rembChecked"></el-checkbox>
          <!-- <el-link type="primary" style="color: #222222" @click="toForgetPwdHandle">忘记密码?</el-link> -->
        </div>

        <el-button
          :loading="loading"
          class="login-form-btn"
          type="primary"
          size="mini"
          v-re-click
          @click.native.prevent="loginHandle"
          >登录</el-button
        >
      </el-form>
    </login-index>
  </div>
</template>

<script>
import { getCurrentDomain } from '@/utils'
// 引入组件
import constants from '@/utils/constants'
import Register from '../register/index.vue'
import LoginIndex from '../components/LoginIndex.vue'
import { encryptPassword } from '@/utils/encrypt.js'

export default {
  name: 'Login',
  components: {
    Register,
    LoginIndex
  },
  data() {
    const validateAccount = (rule, value, callback) => {
      const reg1 = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
      const reg2 = /^(?:0|86|\+86)?1[3456789]\d{9}$/
      callback()
      // if (reg1.test(value) || reg2.test(value)) {
      //   callback()
      // } else {
      //   callback(new Error('请输入正确的账号'))
      // }
    }
    const validatePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
        this.showPwdTips = false
      } else {
        callback()
      }
    }
    return {
      formType: 'login',
      loginType: 'wx',
      agreeProtocol: '',
      accountLoginRules: {
        account: [{ required: true, trigger: 'blur', message: '请输入账号' }],
        password: [
          {
            required: true,
            trigger: 'blur',
            message: '输入6-20位字符，大小写字母+数字组合'
          },
          { trigger: 'blur', validator: validatePwd }
        ]
      },
      accountForm: {
        email: '',
        phoneNumber: '',
        password: ''
      },
      wxQrCodeLoading: true,
      wxLoginQrCode: '',
      wxLoginId: '',
      refreshWxQrcodeTimer: null,
      wxQrcodeResultTimer: null,
      qqLoginAuthorizeUrl: '',
      enableWx: false,
      rembChecked: false,
      errorTips: '',
      loading: false,
      passwordType: 'password'
    }
  },
  computed: {},
  watch: {},
  async created() {
    let sysRes = await this.$api.get('/public/systemInfoConfig')
    let { openWxMpLogin } = JSON.parse(sysRes.data)
    this.enableWx = openWxMpLogin || false
    if (this.enableWx) {
      const self = this
      this.getLoginWxQrCode()
      this.refreshWxQrcodeTimer = setInterval(() => {
        if (self.loginType == 'account') {
          // 如果是账号登录模式就暂停轮询
          return
        }
        this.getLoginWxQrCode()
      }, 5 * 60 * 1000)
      this.wxQrcodeResultTimer = setInterval(() => {
        if (self.loginType == 'account') {
          // 如果是账号登录模式就暂停轮询
          return
        }
        this.getLoginWxQrCodeResult()
      }, 5 * 1000)
      // this.getQQLoginAuthorizeUrl()
    } else {
      this.loginType = 'account'
    }

    let accountForm = JSON.parse(localStorage.getItem('accountForm'))

    if (accountForm) {
      this.accountForm = accountForm.accountForm
      this.rembChecked = accountForm.rembChecked
    }
  },
  destroyed() {
    clearInterval(this.refreshWxQrcodeTimer)
    clearInterval(this.wxQrcodeResultTimer)
  },
  methods: {
    // 获取微信登录二维码
    getLoginWxQrCode() {
      this.wxQrCodeLoading = true
      this.$api.get('/login/wx/qrcode').then((res) => {
        this.wxLoginQrCode = res.data.qrCodeUrl
        this.wxLoginId = res.data.loginId
      })
    },
    // 忘记密码
    toForgetPwdHandle() {
      this.$router.push({ path: '/forget/password' })
    },
    // qq登录授权地址
    getQQLoginAuthorizeUrl() {
      let reUrl = getCurrentDomain() + '/redirect/qqlogin'
      this.$api
        .get('/login/qq/authorize/url', {
          params: { redirectUri: reUrl }
        })
        .then((res) => {
          this.qqLoginAuthorizeUrl = res.data
        })
    },
    redirectUrl(url) {
      location.href = url
    },
    getLoginWxQrCodeResult() {
      this.$api
        .get('/login/wx/qrcode/result', {
          params: { loginId: this.wxLoginId }
        })
        .then((res) => {
          if (res.data) {
            this.loginSuccessHandle(res.data)
          }
        })
    },
    loginSuccessHandle(data) {
      this.msgSuccess('登录成功')
      this.$store.dispatch('user/login', data).then(() => {
        // 重置状态
        this.$store.dispatch('global/loginExpired', false).then(() => {})
        // 登录成功后路由跳回
        console.log('this.$router', this.$router.query)
        if (this.$route.query.redirect) {
          this.$router.replace({
            path: this.$route.query.redirect
          })
        } else {
          console.log('--跳转')
          this.$router.push({ path: '/home' })
        }
      })
    },
    registerSuccessHandle() {
      this.formType = 'login'
      this.loginType = 'account'
    },
    loginHandle() {
      const { password } = this.accountForm
      var rsaPassWord = encryptPassword(password) // 对内容进行加密
      let params = {
        ...this.accountForm,
        password: rsaPassWord
      }
      this.$refs['accountLoginForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$api
            .request({
              url: '/login/account',
              method: 'post',
              data: params
            })
            .then((res) => {
              this.loading = false
              if (res.code == 200) {
                this.loginSuccessHandle(res.data)
                this.cacheAccountAndPassword()
                // 清空接口缓存
                const PATH = process.env.VUE_APP_API_ROOT + '/workOrderLogic/querySimpleFormNameMap'
                this.$store.commit('cache/clearCache', `${PATH}>respone`)
              }
            })
            .catch((err) => {
              this.loading = false
              // this.errorTips = err.msg
              var a = this.accountLoginRules.password[1].validator
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    cacheAccountAndPassword() {
      let { accountForm, rembChecked } = this
      if (rembChecked) {
        let setItem = JSON.stringify(Object.assign({ accountForm }, { rembChecked }))
        localStorage.setItem('accountForm', setItem)
      } else {
        localStorage.removeItem('accountForm')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/styles/login.scss';
</style>
